export default "__VITE_ASSET__BzBjdl7M__"